export default __webpack_public_path__ + "static/nht_color-a46ad2aaca43a65f76ff0da504aa3f42.png";